export default "__VITE_PUBLIC_ASSET__3768d117__"